/* @flow */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import MediaQuery from 'react-responsive';

import Pagination from '@uniiverse/library/components/pagination';
import UniverseLogo from '@uniiverse/library/assets/universe.svg';

import style from './index-module.css';

type Events = Array<{ url: string }>;

type Props = ProfileQuery & {
  currentUser: Object,
  events: Events,
  totalCount: number,
  currentPage: number,
  changePage: Function
};

export const EVENT_COUNT_LIMIT: number = 10;
const MOBILE_BREAK_POINT: number = 751;

const PoweredBy: Function = (): React$Element<*> => (
  <div className={`${style.info} ${style.poweredBy}`}>
    <FormattedMessage id="profile.powered-by" defaultMessage="Powered by" />
    <UniverseLogo />
  </div>
);

const AddWidgetNote: Function = (): React$Element<*> => {
  return <div className={style.info}>
    <FormattedMessage id="profile.live-widget" defaultMessage="Like this widget?" />&nbsp;
    <a href="https://www.universe.com/help/articles/360002276392" target="_blank">
      <FormattedMessage id="profile.add-widget" defaultMessage="Learn how to add it to your website" />
    </a>
  </div>;
};

const EventsFooter: Function = (props: Props): React$Element<*> => {
  const { profile, currentUser, events, totalCount, currentPage, changePage } = props;
  const pageCount: number = Math.ceil(totalCount / EVENT_COUNT_LIMIT);

  return <div className={style.container}>
    <MediaQuery maxWidth={MOBILE_BREAK_POINT}>
      <PoweredBy />
    </MediaQuery>
    <MediaQuery minWidth={MOBILE_BREAK_POINT + 1}>
      {currentUser && currentUser.id === profile.id && events.length > 0 ? <AddWidgetNote /> : <PoweredBy />}
    </MediaQuery>
    <div className={style.pagination}>
      <Pagination
        pageCount={pageCount}
        currentPage={currentPage}
        pageRangeDisplayed={1}
        marginPagesDisplayed={1}
        onPageChange={changePage}
      />
    </div>
  </div>;
};

export default EventsFooter;



// WEBPACK FOOTER //
// ./src/components/profile/events-footer/index.js